import getStaticData from '../helpers/getStaticData'
import callAPI from '../helpers/callAPI'
import { REQUEST_SUBMIT_FORM, receiveSubmitForm } from '../actions/submitting'

const submitting = store => next => action => {
  next(action)

  if (action.type !== REQUEST_SUBMIT_FORM) {
    return
  }

  const dispatch = store.dispatch

  try {
    const groupOffersApiConfig = getStaticData('groupofferrequest')
    callAPI(
      {
        url: groupOffersApiConfig.url,
        method: 'POST',
        payload: action.data,
      },
      { ...groupOffersApiConfig.headers }
    ).then(data => {
      new RegExp(/^TRAN-TIP-CS-WORK-INTERACTION WEB-\d+/).test(data.ID)
        ? dispatch(receiveSubmitForm('success'))
        : dispatch(receiveSubmitForm('failure'))
    })
  } catch (error) {
    dispatch(receiveSubmitForm('failure'))
  }
}

export { submitting }
